<t4-header></t4-header>
<t4-container title="{{ 'Order.Sales.Map.lblFilter' | translate : 'Filter'}}">
  <div class="row">
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Order.Sales.Map.lblChain' | translate : 'Chain'}}</mat-label>
        <mat-select [(ngModel)]="selectedChains" required matNativeControl multiple #selectedChain>
           <mat-option [value]="0" (click)="toggleAllSelection()">Select All</mat-option>
           <mat-option [value]="chain" *ngFor="let chain of availableChains">{{ chain }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Order.Sales.Map.lblMinContracts' | translate : 'Min. contracts'}}</mat-label>
        <input type="number" [(ngModel)]="minContracts" matInput />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Order.Sales.Map.lblMaxContracts' | translate : 'Max. contracts'}}</mat-label>
        <input type="number" [(ngModel)]="maxContracts" matInput />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Order.Sales.Map.lblExpires' | translate : 'Has expirations within'}}</mat-label>
        <mat-select required [(ngModel)]="expiresIn" matNativeControl>
          <mat-option value="100">{{ 'Order.Sales.Map.lblAll' | translate : 'All'}}</mat-option>
          <mat-option value="1">1 {{ 'Order.Sales.Map.lblMonth' | translate : 'month'}}</mat-option>
          <mat-option value="2">2 {{ 'Order.Sales.Map.lblMonth' | translate}}</mat-option>
          <mat-option value="3">3 {{ 'Order.Sales.Map.lblMonth' | translate}}</mat-option>
          <mat-option value="4">6 {{ 'Order.Sales.Map.lblMonth' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4"><button mat-raised-button color="primary" (click)="update()">{{ 'Order.Sales.Map.cmdUpdate' | translate : 'Update'}}</button></div>
  </div>
  
</t4-container>
<br/>
<t4-container title="">
  <mat-tab-group>
    <mat-tab label="{{ 'Order.Sales.Map.lblMap' | translate : 'Map'}}">
      <div class="mapContainer">
        <div #gmap style="height: calc(100vh - 500px); min-height: 400px; width: 100%;"></div>
        <div class="mapFunctions">
          <div class="mapFilterBox">
            <mat-form-field>
              <input #txtMapSearch matInput placeholder="{{ 'Turbo.Order.Map.lblLocationSearch' | translate : 'Find location'}}" type="text" (focus)="onSearchFocus()" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab [label]="selectedCustomer.Name" *ngIf="selectedCustomer">
      <t4-turbo-customerInfo [(customerId)]="selectedCustomer.Id" #customerInfo> </t4-turbo-customerInfo>
      <t4-data-table #tblActiveContracts apiMethod="TurboOrder/GetActiveTrailersForCustomer" [parameters]="{ customerId: selectedCustomer.Id }" matSortActive="OffRentDate" matSortDirection="asc" [filterFields]="['RegNo', 'Alias', 'PricePerMonth', 'StartWeek', 'TerminationDate', 'EndContract', 'VehicleId']" headline="{{ 'TO.ActiveContracts.Trailers_ActiveTrailers' | translate : 'Active objects' }}" matSort [autoGenerateColumns]="false">
        <ng-container matColumnDef="openOrder">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 50px;">&nbsp;</mat-header-cell>
          <mat-cell *matCellDef="let row" style="max-width: 50px;" [ngClass]="{ 'deleted': row.Status == 100 && row.OffRentActionExists, expired: row.OffRentDate <= today && row.Status >= 60 && !row.OffRentActionExists, urgent: row.Status >= 60 && row.OffRentDate <= date(45) && !row.OffRentActionExists }" (click)="openContractDialog(row.Id, row.VehicleId)">
            <a class="createSchedule" matTooltip="{{ 'Turbo.Core.ContractsHistory.Table_OpenOrder' | translate : 'Open order' }}">
              <mat-icon>search</mat-icon>
            </a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="RegNo">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 100px;">{{ 'TO.ActiveContracts.Terminate_Trailer_RegNo' | translate : 'Reg. no.' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="max-width: 100px;" [ngClass]="{ 'deleted': row.Status == 100 && row.OffRentActionExists, expired: row.OffRentDate <= today && row.Status >= 60 && !row.OffRentActionExists, urgent: row.Status >= 60 && row.OffRentDate <= date(45) && !row.OffRentActionExists }" (click)="openContractDialog(row.Id, row.VehicleId)">{{ row.RegNo }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px;">{{  'TO_Order_Status' | translate : 'Status'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="max-width: 150px;" [ngClass]="{ 'deleted': row.Status == 100 && row.OffRentActionExists, expired: row.OffRentDate <= today && row.Status >= 60 && !row.OffRentActionExists, urgent: row.Status >= 60 && row.OffRentDate <= date(45) && !row.OffRentActionExists }" (click)="openContractDialog(row.Id, row.VehicleId)">
            {{  'TO.ActiveContracts.Contract_Status' + row.Status | translate }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Alias">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_Trailer_Model' | translate : 'Model' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ 'deleted': row.Status == 100 && row.OffRentActionExists, expired: row.OffRentDate <= today && row.Status >= 60 && !row.OffRentActionExists, urgent: row.Status >= 60 && row.OffRentDate <= date(45) && !row.OffRentActionExists }" (click)="openContractDialog(row.Id, row.VehicleId)">{{ row.Alias }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="CostPerMonth">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 100px;">{{ 'TO.ActiveContracts.Terminate_PricePerMonth' | translate : 'Cost / month' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="max-width: 100px;" [ngClass]="{ 'deleted': row.Status == 100 && row.OffRentActionExists, expired: row.OffRentDate <= today && row.Status >= 60 && !row.OffRentActionExists, urgent: row.Status >= 60 && row.OffRentDate <= date(45) && !row.OffRentActionExists }" (click)="openContractDialog(row.Id, row.VehicleId)">{{row.PricePerMonth | number : '1.0-0' }}kr</mat-cell>
        </ng-container>
        <ng-container matColumnDef="StartWeek">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 150px;">{{ 'TO.ActiveContracts.Terminate_StartDate' | translate : 'Start date' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="max-width: 150px;" [ngClass]="{ 'deleted': row.Status == 100 && row.OffRentActionExists, expired: row.OffRentDate <= today && row.Status >= 60 && !row.OffRentActionExists, urgent: row.Status >= 60 && row.OffRentDate <= date(45) && !row.OffRentActionExists }" (click)="openContractDialog(row.Id, row.VehicleId)">{{row.OnRentDate | date: 'yyyy-MM-dd'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="TerminationDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 150px;">{{ 'TO.ActiveContracts.Terminate_TerminationDate' | translate : 'End date' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="max-width: 150px;" [ngClass]="{ 'deleted': row.Status == 100 && row.OffRentActionExists, expired: row.OffRentDate <= today && row.Status >= 60 && !row.OffRentActionExists, urgent: row.Status >= 60 && row.OffRentDate <= date(45) && !row.OffRentActionExists }" (click)="openContractDialog(row.Id, row.VehicleId)">{{ row.TerminationDate | date: 'yyyy-MM-dd' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="ExtendedTo">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 150px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="max-width: 150px;" [ngClass]="{ 'deleted': row.Status == 100 && row.OffRentActionExists, expired: row.OffRentDate <= today && row.Status >= 60 && !row.OffRentActionExists, urgent: row.Status >= 60 && row.OffRentDate <= date(45) && !row.OffRentActionExists }" (click)="openContractDialog(row.Id, row.VehicleId)">
            <mat-icon style="color:#1e9b38" *ngIf="row.ExtendedTo" title="{{ row.ExtendedTo | date: 'yyyy-MM-dd' }}">schedule</mat-icon>
          </mat-cell>
        </ng-container>
      </t4-data-table>
    </mat-tab>
    <mat-tab label="{{'Order.Sales.Create New Prospect.lblCreatenewprospect' | translate : 'Create new prospect'}}" *ngIf="Show">
      <div class="row">
        <div class="col-4">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Order.Sales.Map.lblLatLong' | translate : 'Lat Long'}}</mat-label>
            <input type="text" matInput [value]="latLng" readonly />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Order.Sales.Map.lblAddress' | translate : 'Address'}}</mat-label>
            <input type="text" matInput [(ngModel)]="address" readonly />
          </mat-form-field>
          <form name="brandForm" novalidate>
            <mat-label>{{ 'Order.Sales.Map.lblBrand' | translate : 'Brand'}}*</mat-label><br />
            <mat-radio-group class="btn-group-vertical well" [(ngModel)]="selectedBrand" name="brand">
              <mat-radio-button class="radio-button" color="primary" *ngFor="let brand of brands" [value]="brand">
                {{brand}}
              </mat-radio-button>
            </mat-radio-group>
            <p><span style="color:red" *ngIf="!prospectSaved">Fields marked with * are mandatory!.</span></p>
          </form>
          <mat-form-field appearance="outline">
            <input type="text" [(ngModel)]="name" matInput required #txtName="ngModel" />
            <mat-label class="custom-control-label">{{ 'Order.Sales.Map.lblName' | translate : 'Name'}}</mat-label>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Order.Sales.Map.lblDescription' | translate : 'Description'}}</mat-label>
            <textarea type="text" rows="5" [(ngModel)]="description" matInput></textarea>
          </mat-form-field>
        </div><br />
        <div class="col-4"><button type="submit" mat-raised-button color="primary" (click)="saveNewProspect()">Create</button></div>
      </div>
    </mat-tab>
    <mat-tab label="{{'Order.Sales.Update Prospect.lblUpdatedeleteprospect' | translate : 'Update / Delete prospect'}}" *ngIf="showUpdateProspect">
      <div class="row">
        <div class="col-4">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Order.Sales.Map.lblLatLong' | translate : 'Lat Long'}}</mat-label>
            <input type="text" matInput [(ngModel)]="updateLatlng" readonly />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Order.Sales.Map.lblAddress' | translate : 'Address'}}</mat-label>
            <input type="text" matInput [(ngModel)]="address" readonly />
          </mat-form-field>
          <form name="brandUpdateForm" novalidate>
            <mat-label>{{ 'Order.Sales.Map.lblBrand' | translate : 'Brand'}}*</mat-label><br/>
            <mat-radio-group class="btn-group-vertical well" [(ngModel)]="updateBrand" name="brand">
              <mat-radio-button class="radio-button" color="primary" *ngFor="let brand of brands" [value]="brand" required>
                {{brand}}
              </mat-radio-button>
            </mat-radio-group>
            <div><p><span style="color:red" *ngIf="!prospectUpdated">Fields marked with * are mandatory!.</span></p></div>
          </form>
          <mat-form-field appearance="outline">
            <input type="text" [(ngModel)]="updateName" matInput required #txtupdateName="ngModel" />
            <mat-label class="custom-control-label">{{ 'Order.Sales.Map.lblupdateName' | translate : 'Name'}}</mat-label>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Order.Sales.Map.lblDescription' | translate : 'Description'}}</mat-label>
            <textarea type="text" [(ngModel)]="updateDescription" rows="5" matInput></textarea>
          </mat-form-field>
        </div><br />
        <div class="col-lg-1">
          <button type="button" mat-raised-button color="primary" (click)="updateProspect()">Update</button>
        </div>
        <div class="col-lg-1">
          <button type="button" mat-raised-button color="primary" (click)="deleteProspect()">Delete</button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</t4-container>

